import React from "react";
import PageViewPixel from "./facebook/PageViewPixel";
import ViewTicketsContent from "./facebook/ViewTicketsContent";

export default function Pixel({ name }) {
  return (
    <>
      {name === "PageViewPixel" && <PageViewPixel />}
      {name === "ViewTicketsContent" && <ViewTicketsContent />}
    </>
  );
}